
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import { login } from '@api/connectors/sycrect'
import { CONNECTOR_TYPES } from '@/vars/general'

const TASKS = [
    {
        title: 'Обратитесь к менеджеру Sycret',
        body: 'Попросите предоставить API-ключ для интеграции с Data Heroes.',
    },
    {
        title: 'Дождитесь ответа',
        body: 'Когда ключ пришлют, скопируйте его без пробелов.',
    },
    {
        title: 'Вставьте ключ в поле',
        body: 'После этого мы сможем завершить интеграцию.',
    },
]

export default {
    name: 'SycretAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const validLogin = ref<boolean | null>(null)
        const loading = ref(false)
        const apiKey = ref('')

        const btnDisabled = computed(() => !String(apiKey.value || '').trim())

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const credentials = { apiKey: apiKey.value }
            const projectId = root.$router.currentRoute.params.id
            const connector = await store.dispatch('project/createConnector', {
                projectId,
                connectorType: CONNECTOR_TYPES.sycret,
            })
            const isLogin = await login(connector, credentials)
            if (isLogin) {
                store.commit('project/setLoggedAddingConnector', connector)
                root.$parent.$emit('login')
            }
            validLogin.value = isLogin
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Войти',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            apiKey,
            validLogin,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
